<template>
  <div class="text-center" v-if="task">
    <v-dialog v-model="display" :width="width" persistent :fullscreen="$vuetify.breakpoint.xsOnly || fullscreen">
      <v-card>
      <v-card-title style="padding: 4px">
          <v-btn icon color="red" flat outline text @click="resetReport()">
            <v-icon>summarize</v-icon>
          </v-btn>
          <v-btn  flat icon color="primary" outline text @click="uploadFun()">
            <v-icon>file_upload</v-icon>
          </v-btn>
          <v-btn  flat icon color="primary" outline text :href="docURL" target="_blank">
            <v-icon>file_download</v-icon>
          </v-btn>
          <v-btn  flat outline icon color="warning" text @click="sendMailFun()">
            <v-icon>send</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat icon color="primary" @click.stop="fullscreen=!fullscreen" v-if="!$vuetify.breakpoint.xsOnly">
            <v-icon>fit_screen</v-icon>
          </v-btn>
          <v-btn flat icon  color="primary" @click.stop="close()">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text :style="{height: $vuetify.breakpoint.xsOnly || fullscreen? '94vh': '84vh'}">
        <iframe  style="padding: 0" width="100%" height="100%"
        :src="reviewLink"
        frameborder="0">
        </iframe>
          <input
            v-show="false"
            ref="uploadReportDialog"
            id="uploadReportDialog"
            type="file"
            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            @change="uploadReportSelected($event)"
          />
      </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters  } from 'vuex'

export default {
  name: 'ReportReview',
  props: {
    selectedTask: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      display: true,
      docType: 'office',
      fullscreen: false,
    }
  },
  computed: {
    ...mapGetters({
      task: 'Tasks/getSelectedTask',
    }),
    reportURL() {
      if (!this.task || !this.task.id) {
        return null;
      }
      return this.task.reportURL
    },
    taskId() {
      if (!this.task || !this.task.id) {
        return null;
      }
      return this.task.id
    },
    taskNotes() {
      if (!this.task || !this.task.id) {
        return []
      }
      return this.task.note
    },
    docURL() {
      if (!this.task || !this.task.reportURL) {
        return null;
      }
      const embeddedURL = this.task.reportURL.replace(/\s/g, '%20')
      return embeddedURL
    },
    reviewLink(){
      console.log('doclink', this.docURL)
      if (!this.docURL) {
        return null
      }
      const doclink = `https://view.officeapps.live.com/op/embed.aspx?src=${this.docURL}`
      console.log('doclink', doclink)
      return doclink
    },
    width() {
      const w = Math.min(window.innerWidth, 800)
      console.log({width:w, 'window.innerWidth': window.innerWidth})
      return w;
    }
  },
  methods: {
    ...mapActions({
      sendReport: 'Tasks/sendReport',
      uploadReport: 'Tasks/uploadReport',
      generateReport: 'Tasks/generateReport',
    }),
    sendMailFun() {
      this.$confirm({
        message: `You are about to send report to owner and tenant.
          Continue will convert the report to PDF format and send to owner and tenant.
          or Cancel it`,
        title: 'Send report',
        button: {
          yes: 'Continue',
          no: 'Cancel'
        },
        callback: confirm => {
          if (confirm) {
            this.sendReport();
          }
        }
      })
    },
    close() {
      this.display = false;
      console.log('close emmitted')
      this.$emit('close')
    },
    async resetReport() {
      this.$confirm({
        message: `You are about to reset report from its check result and all revisions will be discard.
          Continue will re-generate the report from its check result.
          or Cancel it to cancel the re-regenation`,
        title: 'Re-generate report',
        button: {
          yes: 'Continue',
          no: 'Cancel'
        },
        callback: confirm => {
          if (confirm) {
            this.generateReport(this.selectedTask, false);
          }
        }
      });

    },

    async uploadFun() {
      this.$confirm({
        message: `You are about uploading an external docx file to replace the auto-generated report.
          Continue will upload the report and archive it as a formal report.
          or Discard it to discard all modification you made on the local copy`,
        title: 'Upload a manual revision',
        button: {
          yes: 'Continue',
          no: 'Discard'
        },
        callback: confirm => {
          if (confirm) {
            this.$refs.uploadReportDialog.click();
          }
        }
      });
    },
    async uploadReportSelected(event) {
      let localFile = event ? event.target.files[0] : null
      if (!localFile) {
        return
      }

      console.log(localFile)
      const formData = new FormData()
      formData.append('file', localFile)
      formData.append('task_id', this.taskId)
      await this.uploadReport(formData)
    },

  },
}
</script>
<style scoped>
.v-card__title {
  background-color: lightyellow;
}
</style>